@if (loaded()) {
  <h1 mat-dialog-title>Dagdeel {{ isEditing() ? 'wijzigen' : 'toevoegen' }}</h1>
  <div mat-dialog-content>
    <form [formGroup]="daypartsForm">
      <mat-form-field class="name">
        <mat-label>Naam</mat-label>
        <input matInput type="text" autocomplete="off" formControlName="name" required />
        @if (daypartsForm.controls.name.errors?.required) {
          <mat-error>Dit veld is verplicht.</mat-error>
        }
      </mat-form-field>
      <mat-form-field class="day">
        <mat-label>Dag</mat-label>
        <mat-select formControlName="day" required>
          @for (day of days; track day) {
            <mat-option [value]="day">{{ day }}</mat-option>
          }
        </mat-select>
        @if (daypartsForm.controls.day.errors?.required) {
          <mat-error>Dit veld is verplicht.</mat-error>
        }
      </mat-form-field>
      <div class="form-title">Begin</div>
      <div class="half-fields">
        <mat-form-field class="hour">
          <mat-label>Uur</mat-label>
          <mat-select formControlName="startHour" required>
            @for (hour of hours(); track hour) {
              <mat-option [value]="hour">{{ hour }}</mat-option>
            }
          </mat-select>
          @if (daypartsForm.controls.startHour.errors?.required) {
            <mat-error>Dit veld is verplicht.</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="min">
          <mat-label>Minuten</mat-label>
          <mat-select formControlName="startMin" required>
            @for (min of minutes(); track min) {
              <mat-option [value]="min.val">{{ min.text }}</mat-option>
            }
          </mat-select>
          @if (daypartsForm.controls.startMin.errors?.required) {
            <mat-error>Dit veld is verplicht.</mat-error>
          }
        </mat-form-field>
      </div>
      <div class="form-title">Eind</div>
      <div class="half-fields">
        <mat-form-field class="hour">
          <mat-label>Uur</mat-label>
          <mat-select formControlName="endHour" required>
            @for (hour of hours(); track hour) {
              <mat-option [value]="hour">{{ hour }}</mat-option>
            }
          </mat-select>
          @if (daypartsForm.controls.endHour.errors?.required) {
            <mat-error>Dit veld is verplicht.</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="min">
          <mat-label>Minuten</mat-label>
          <mat-select formControlName="endMin" required>
            @for (min of minutes(); track min) {
              <mat-option [value]="min.val">{{ min.text }}</mat-option>
            }
          </mat-select>
          @if (daypartsForm.controls.endMin.errors?.required) {
            <mat-error>Dit veld is verplicht.</mat-error>
          }
        </mat-form-field>
      </div>
      @if (data.type === 'driver') {
        <div class="form-title">Voertuigen</div>
        <div class="vehicle-selection">
          @for (vehicle of vehicles(); track vehicle.id) {
            <mat-checkbox
              class="vehicle-checkbox"
              (change)="handleVehicleClick($event, vehicle.id)"
              [checked]="vehicleChecked(vehicle.id)"
              >{{ vehicle.name }}
            </mat-checkbox>
          }
        </div>
      }
      @if (this.isEditing()) {
        <mat-error
          >Deze wijziging heeft alleen effect op dagdeeldagen waar nog geen
          {{ data.type === 'planner' ? 'planners zijn gekoppeld.' : 'chauffeur is gekoppeld.' }}</mat-error
        >
      }
    </form>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]>Annuleren</button>
    <button mat-flat-button (click)="addDaypart()" [disabled]="!daypartsForm.valid">Opslaan</button>
  </div>
} @else {
  <div mat-dialog-content>
    <mat-spinner></mat-spinner>
  </div>
}
